import { canUseTrackingTool } from './trackingToolValidate'

/**
 * AmplitudeのlogEvent発火
 */
export function amplitudeLogEvent(eventName, eventProperties = {}) {
  if (!canUseTrackingTool()) return
  import('amplitude-js').then(amplitude => {
    const amp = amplitude.default || amplitude
    const screenType = (() => {
      if (typeof window === 'undefined') return ''
      if (window.innerWidth > 767) return 'PC'
      return 'SP'
    })()
    eventProperties['Service'] = 'account'
    eventProperties['Screen'] = screenType
    // location情報
    if (location) {
      if (location.href) eventProperties['Page Url'] = location.href
      if (location.pathname) eventProperties['Page Path'] = location.pathname
      if (location.search) eventProperties['Page Search'] = location.search
    }
    // document情報
    if (document) {
      if (document.referrer)
        eventProperties['Page Referrer'] = document.referrer
    }
    amp.getInstance().logEvent(eventName, eventProperties)
  })
}

/**
 * AmplitudeのsetUserID、setUserPropertiesをコール
 * 引数はviewerFragmentで取得したオブジェクトを指定
 */
export function amplitudeSetUser(user) {
  if (!canUseTrackingTool()) return
  import('amplitude-js').then(amplitude => {
    const amp = amplitude.default || amplitude
    amp.getInstance().setUserId(user.id)
    amp.getInstance().setUserProperties({
      Name: user.name,
      Rank: user.rewardRank.currentRankText,
    })
  })
}
